export enum UserRole {
  User = 'user',
  Admin = 'Admin',
  SysAdmin = 'sysadmin',
}
